import { Injectable, inject } from "@angular/core";
import { Protocol } from "../interfaces/protocols/protocol";
import { ProtocolContentDraft } from "../interfaces/protocols/protocol-content-draft";
import { MatDialog } from "@angular/material/dialog";
import { ProtocolService } from "./protocol.service";
import { ProtocolViewerIframeComponent } from "../modules/protocols/viewer/protocol-viewer-iframe/protocol-viewer-iframe.component";

@Injectable({
	providedIn: "root",
})
export class ProtocolViewerService {
	private dialog = inject(MatDialog);
	private protocolService = inject(ProtocolService);

	viewProtocol(
		protocol: Protocol,
		content?: null | string | ProtocolContentDraft,
		isLeft: boolean = false,
		isPublished: boolean = true
	): void {
		const dialogRef = this.dialog.openDialogs.find(
			(dialog) => dialog.componentInstance instanceof ProtocolViewerIframeComponent
		);
		if (dialogRef) {
			dialogRef.close();
		}

		const panelClass = ["lightTheme"];
		let hasBackdrop = true;
		if (isLeft) {
			panelClass.push("left-half-centered-dialog");
			hasBackdrop = false;
		}

		const commonConfig = {
			width: "90%",
			height: "90%",
			autoFocus: false,
			id: "protocolViewerDialog",
			panelClass,
			hasBackdrop,
		};

		if (isLeft) {
			commonConfig["maxWidth"] = "50vw";
		}

		if (!content) {
			// Open immediately — component will fetch content and show shimmer
			this.dialog.open(ProtocolViewerIframeComponent, {
				data: {
					protocol: protocol,
					content: null,
					isPublished: isPublished,
				},
				...commonConfig,
			});
		} else if (typeof content == "string") {
			this.dialog.open(ProtocolViewerIframeComponent, {
				data: {
					protocol: protocol,
					content: content,
					isPublished: true,
				},
				...commonConfig,
			});
		} else {
			this.dialog.open(ProtocolViewerIframeComponent, {
				data: {
					protocol: protocol,
					content: this.formatBody(content),
					isPublished: false,
				},
				...commonConfig,
			});
		}
	}

	closeViewer(): void {
		const dialogRef = this.dialog.openDialogs.find(
			(dialog) => dialog.componentInstance instanceof ProtocolViewerIframeComponent
		);
		if (dialogRef) {
			dialogRef.close();
		}
	}

	formatBody(content: ProtocolContentDraft): string {
		return `<div style="background-color:#005db6;color:white;text-align:center;padding:16px;font-size:25px">Version Brouillon - <i>Non Publiée</i></div><!-- Protocol Body -->${content.content}<script id="mitp-script">${content.code}</script>`;
	}
}
